import { Crown } from "lucide-react";

export function Logo({ size = "md", subtitle = true, className = "" }) {
  const scale = {
    sm: { crown: 18, king: "text-base", sub: "text-[9px]", brand: "text-[10px]" },
    md: { crown: 24, king: "text-xl", sub: "text-[10px]", brand: "text-xs" },
    lg: { crown: 34, king: "text-3xl", sub: "text-xs", brand: "text-sm" },
  }[size];

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div className="flex h-9 w-9 items-center justify-center rounded-full gold-border" style={{ background: "rgba(226,184,87,0.08)" }}>
        <Crown size={scale.crown} className="gold-text" strokeWidth={1.6} />
      </div>
      <div className="leading-tight">
        <div className={`font-serif font-bold tracking-wide text-[#F9F6F0] ${scale.king}`}>
          KING'S
        </div>
        <div className={`overline-label ${scale.sub} -mt-0.5`}>Professional Salon</div>
        {subtitle && (
          <div className={`gold-text font-semibold tracking-[0.2em] uppercase ${scale.brand} mt-0.5`}>
            Smart Massage
          </div>
        )}
      </div>
    </div>
  );
}
